export interface UseStoryblokVexatiousClausesProps {
    slug: string;
    enabled: MaybeRefOrGetter<boolean>;
}

export type UseStoryblokVexatiousClausesReturn = Readonly<Ref<string>>;

export const useStoryblokVexatiousClauses = ({ slug, enabled }: UseStoryblokVexatiousClausesProps): UseStoryblokVexatiousClausesReturn => {
    const { isDefaultLocale, locale } = useTypedI18n();
    const storyblokApi = useStoryblokApi();
    const vexatiousClauses = ref('');

    watch(
        () => toValue(enabled),
        async val => {
            if (!val) return;

            const { data } = await storyblokApi.getStory(resolveStoryblokSlug(slug), {
                version: 'published',
                ...(!isDefaultLocale.value ? { language: locale.value } : {}),
            });

            vexatiousClauses.value = data?.story?.content?.vexatiousClauses ?? '';
        },
        { immediate: true }
    );

    return readonly(vexatiousClauses);
};
